import TestingDashboard from "@/features/testing/views/TestingDashboard.vue";
import AlertTesting from "@/features/testing/views/AlertTesting.vue";

// attention: do not add a slash in front of the paths as this will break the routing.
// For example the router will see it as a root path like '/dashboard' instead of '/whatever/dashboard'.
export default [
  { path: "", component: TestingDashboard, name: "testing-dashboard" },
  { path: "alert", component: AlertTesting, name: "alert-testing" },
];
